import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const one = (
      <p>
        I am currently entering my 3rd year and studying <b>Computer Science</b> at
        <a href="https://www.uel.ac.uk/" target="_blank">
          {" "}
          University of East London
        </a>
        <br />
        I am currently interning as a Software Developer at <a href="https://www.teamoreo.co.uk/" target="_blank"> Team Oreo</a> working on a full stack web application 🤫.
      </p>
    );
    const two = (
      <p>
        Outside of tech, I'm working out my body, reading personal development books and playing video games.
      </p>
    );

    const desc_items = [one, two];

    const tech_stack = [
      "Javascript ES6+",
      "AWS",
      "React.js",
      "Java",
      "Node.js",
      "HTML & CSS"
    ];

    const tech_items = tech_stack.map(stack => <li>{stack}</li>);

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/ about me</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              {"Here are some technologies I have been working with:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
